import { FocusResa } from '../core/focusResa';
import { atom, getDefaultStore } from 'jotai';
import { luxonLocalizer } from 'react-big-calendar';
import * as luxon from 'luxon';

export const focusResaAtom = atom(() => FocusResa.getInstance());

luxon.Settings.defaultZone = 'UTC+2';
const localizer = luxonLocalizer(luxon.DateTime);
localizer.formats.timeGutterFormat = 'T';
export const rbcLocalizerAtom = atom(localizer);

(window as any).store = getDefaultStore();
